import { onError } from '@apollo/client/link/error';
import { isAuthlessPathname } from 'utils/router';
import { logger } from 'modules/logger';

/**
 * Handles GraphQL and network errors, and redirects to /logout on UNAUTHENTICATED
 * for pages that require auth.
 */
export const logoutLink = onError(({ operation, graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      if (extensions?.code === 'PERSISTED_QUERY_NOT_FOUND') {
        logger.error(`[GraphQL error]: Message: ${message}, Operation: ${operation.operationName}`);
      } else if (extensions?.code !== 'UNAUTHENTICATED') {
        logger.error(
          `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
            locations
          )}, Path: ${path}`
        );
      }
    });

    if (networkError) {
      if (networkError.message !== 'Failed to fetch') {
        // These logs will have a linked Error within analytics tools.
        logger.error(`[Network error]: ${networkError.message}`);
      } else {
        // These can be from CORS, internet instability
        logger.error(`[Unknown Network error]: ${networkError.message}`);
      }
    }

    const shouldLogout = graphQLErrors.some(
      (error) =>
        error.extensions?.code === 'UNAUTHENTICATED' &&
        !isAuthlessPathname(window.location.pathname)
    );

    if (shouldLogout) {
      logger.info('[Apollo Client]: Logging out due to receiving UNAUTHENTICATED from GraphQL');
      window.location.href = '/logout';
    }
  }
});
